<template>
	<view class="addOpinion-wrap">
		<u-popup v-model="popupShow" mode="center" width="90%" border-radius="8" closeable>
			<view class="addOpinion-wrap-inside">
				<view class="addOpinion-title">意见与建议</view>
				<u-form>
					<u-form-item>
						<u-input 
						   :border="true" 
						   type="textarea" 
						   v-model="content" 
						   :height="height"
						   auto-height
						   placeholder="请输入您的意见与建议"></u-input>
					</u-form-item>
				</u-form>
				<view class="btn-box">
					<u-button style="margin-right: 40rpx;" type="info" @click="cancel">取消</u-button>
					<u-button type="success" @click="submit">提交</u-button>
				</view>
			</view>
			
		</u-popup>
	</view>
</template>

<script>
	export default {
		name:"addOpinion",
		data() {
			return {
				height:260, //input的高度
				popupShow: false,
				content:'',
			};
		},
		methods: {
			init() {
				this.popupShow = true
				this.content = ''  //清空表单内容
			},
			submit() {
				let params = {
					content: this.content,
					customerId: this.$store.state.customerId
				}
				this.$u.api.insertSuggest(params).then(res => {
					if(res.code == 200) {
						this.popupShow = false
						this.$emit('refeshOpinionList')
						this.$u.toast(res.message)
					}
				})
			},
			cancel() {
				this.popupShow = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.addOpinion-wrap-inside{
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
	}
   .addOpinion-title{
	   text-align: center;
	   font-size: 32rpx;
	   color: #111111;
	   font-weight: light;
   }
   .btn-box{
	   display: flex;
	   justify-content: center;
   }
</style>
